// Only unwrap the active Controller snapshot. Null is authoritative, never a fallback.
export const canonicalContext = (state) => ({
  ...state.session.detail?.context,
  ...Object.fromEntries(Object.entries(state.projections ?? {})
    .filter(([, envelope]) => envelope?.sessionId === state.session.sessionId)
    .map(([key, envelope]) => [key, envelope.payload])),
});
